module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_molndal-f0168a85bc93d771b17633c287a3dc2e.png";